var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "Cập nhật api role",
        visible: _vm.dialogVisible,
        width: "40%",
        "before-close": _vm.closeDialog,
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "updateApiRole",
          attrs: {
            "label-width": "120px",
            model: _vm.updateApiRole,
            "label-position": "left",
            rules: _vm.rules,
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "Tên api", prop: "apiName" } },
            [
              _c("el-input", {
                attrs: { placeholder: "Nhập tên api" },
                model: {
                  value: _vm.updateApiRole.apiName,
                  callback: function ($$v) {
                    _vm.$set(_vm.updateApiRole, "apiName", $$v)
                  },
                  expression: "updateApiRole.apiName",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "Tên đường dẫn ", prop: "apiUrl" } },
            [
              _c("el-input", {
                attrs: { placeholder: "Nhập tên api" },
                model: {
                  value: _vm.updateApiRole.apiUrl,
                  callback: function ($$v) {
                    _vm.$set(_vm.updateApiRole, "apiUrl", $$v)
                  },
                  expression: "updateApiRole.apiUrl",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "Mô tả api", prop: "apiDescription" } },
            [
              _c("el-input", {
                attrs: {
                  rows: 1,
                  type: "textarea",
                  autosize: "",
                  placeholder: "Nhập mô tả",
                },
                model: {
                  value: _vm.updateApiRole.apiDescription,
                  callback: function ($$v) {
                    _vm.$set(_vm.updateApiRole, "apiDescription", $$v)
                  },
                  expression: "updateApiRole.apiDescription",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "danger", size: "medium" },
              on: {
                click: function ($event) {
                  return _vm.closeDialogByButton("updateApiRole")
                },
              },
            },
            [
              _c("i", { staticClass: "el-icon-circle-close" }),
              _c("span", [_vm._v("Đóng")]),
            ]
          ),
          _c(
            "el-button",
            {
              attrs: {
                type: "success",
                size: "medium",
                loading: _vm.loadingButton,
                mini: "",
              },
              on: {
                click: function ($event) {
                  return _vm.submitForm("updateApiRole")
                },
              },
            },
            [
              _c("i", { staticClass: "el-icon-circle-check" }),
              _c("span", [_vm._v("Lưu")]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }